export const colorMappings ={
  "#E63B50": {
    secondaryColor: "#FBD0D3",
    tertiaryColor: "#FDE6E7",
  },
  "#E38E2B": {
    secondaryColor: "#F6DFB2",
    tertiaryColor: "#FDE6E7",
  },
  "#D32D5E": {
    secondaryColor: "#F9D1E2",
    tertiaryColor: "#FBE8F0",
  },
  "#4B089F": {
    secondaryColor: "#DBCFFF",
    tertiaryColor: "#ECE5FF",
  },
  "#364391": {
    secondaryColor: "#CAD8F3",
    tertiaryColor: "#E1E9F8",
  },
  "#39ACAB": {
    secondaryColor: "#D5F2EF",
    tertiaryColor: "#F2FFFE",
  },
  "#E70A89": {
    secondaryColor: "#FFE4F7",
    tertiaryColor: "#FFF4FC",
  },
  "#DF005D": {
    secondaryColor: "#FFE4F3",
    tertiaryColor: "#FFF0F8",
  },
  "#F2709C": {
    secondaryColor: "#FAD0E0",
    tertiaryColor: "#FCE7EF",
  },
  "#FF9472": {
    secondaryColor: "#FFDFD4",
    tertiaryColor: "#FFEFEA",
  },
  "#282D4A": {
    secondaryColor: "#3A3F5C",
    tertiaryColor: "#4A4F6E",
  },
}